import React, { useEffect } from 'react'
import { Hook } from '../hooks/Hook'
import { useSingletonMVUReducer } from '../mvuReducer'
import { subjectId, WebRecorder2Action, WebRecorder2SideEffect, WebRecorder2State } from './webRecorder2'
import { broadcastRecordingState } from './liveView'
import { Loading } from '~/components/Loading'
import { useWebRecorderPubSubSubscribe } from './useWebRecorderPubSubSubscribe'
import { setHook } from './singleton'

export function WebRecorder2({ hook }: { hook: Hook }): React.ReactElement {
  setHook(hook)

  // TODO: This needs to list the subject IDs that are being recorded
  // const otherRemoteClientIsRecording = hook.el.hasAttribute('data-other-client-is-recording')

  useEffect(() => {
    const handler = async () => {
      await broadcastRecordingState(hook, 'stopped')
    }

    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [])

  const [state, dispatch] = useSingletonMVUReducer<WebRecorder2State, WebRecorder2Action, WebRecorder2SideEffect>(
    'webRecorder2'
  )

  // For non-React elements that depend on the recording state, we need to observe when
  // recording stops and starts so we can disable or enable the buttons/links.
  const isRecording = state?.mode === 'recording'

  useEffect(() => {
    document.querySelectorAll('[data-disable-when-recording]').forEach((el) => {
      if (isRecording) {
        el.setAttribute('disabled', 'true')
      } else {
        el.removeAttribute('disabled')
      }
    })
  }, [isRecording])

  const currentSubjectId = subjectId(state)

  useWebRecorderPubSubSubscribe<WebRecorder2Action & { subjectId?: string }>(
    'apply-action',
    (action: WebRecorder2Action & { subjectId?: string }) => {
      const appliesToCurrentSubject =
        !('subjectId' in action) || action.action === 'set-subject-id' || action.subjectId === currentSubjectId

      if (appliesToCurrentSubject) {
        dispatch?.(action)
      }
    },
    [currentSubjectId]
  )

  // This will never be true since we're the singleton owner
  if (!state) return <Loading size="sm" />
  return <div></div>
}
